import * as React from "react";
import {MouseEvent} from "react";
import LikeComponent from "../../_widgets/like/LikeComponent";
import Style from "../../_data/models/Style";
import {formatWithTags, prettyPrintComment} from "../../_helpers/utils";

interface Props {
    style: Style;
    toggleLike: (e: MouseEvent<HTMLElement>) => void;
    viewFeed: () => void;
}

const ActivityFeedStyleItemComponent = (props: Props) => {
    const {style, toggleLike, viewFeed} = props;

    return (
        <div>
            <div className="row">
                <div className="large-12 columns" onClick={viewFeed}>
                    <div className="post-img v-align-center">
                        <a data-open="postmodal">
                            <img src={style.primaryPictureUrl}/>
                        </a>
                    </div>
                </div>
            </div>
            <div className="row p1">
                <div className="large-12 columns">
                    <ul className="list-inline marginless newsfeed-lgfont">
                        <LikeComponent toggleLike={toggleLike} likable={style as Likable}/>
                        <li>
                            <a onClick={viewFeed}>
                                <i className="fa fa-comment-o fa-fw"/> {prettyPrintComment(style as Commentable)}
                            </a>
                        </li>
                    </ul>
                </div>

                { style.description.trim().length > 0 &&
                <div className="large-12 columns mt-1">
                    <p className="word-wrap-break">{formatWithTags(style.description)}</p>
                </div>
                }
            </div>
        </div>
    );
};
export default ActivityFeedStyleItemComponent;


// WEBPACK FOOTER //
// ./app/client/activityFeeds/components/ActivityFeedStyleItemComponent.tsx